import { generateNonce } from "@/utils/util";

export default {
  methods: {
    async reSendTwoFactor() {
      this.secondFactorNonce = generateNonce();
      let request = {
        nonce: this.secondFactorNonce,
        userId: this.userId,
      };
      let response = await this.$store.dispatch(
        "session/resendTwoFactor",
        request
      );
      this.secondFactorId = response.secondFactorResponse.secondFactorId;
      this.timer = 29;
      this.startCountDown();
    },
    startCountDown() {
      let countDown = setInterval(() => {
        this.timer--;
        if (this.timer === 0) {
          clearInterval(countDown);
        }
      }, 1000);
    },

    async finishRegistration(registration) {
      await this.clearStore();
      await this.$store.dispatch("session/finishRegistration", registration);
      await this.$store.dispatch("profile/updateStatus", {
        status: "REGISTERED",
        result: "SUCCESS",
      });
      await this.fetchOnLogin();
    },
    async bypassTwoFactor(loginResponse) {
      await this.clearStore();

      let redirect = await this.$store.dispatch(
        "profile/setStatus",
        loginResponse
      );

      await this.fetchOnLogin();

      return redirect;
    },

    async finishLogin(solution) {
      await this.clearStore();

      let loginResponse = await this.$store.dispatch(
        "session/finishLogin",
        solution
      );
      let redirect = await this.$store.dispatch(
        "profile/setStatus",
        loginResponse
      );

      await this.fetchOnLogin();

      return redirect;
    },
    async finishPasswordChange(solution) {
      await this.clearStore();

      let chngResponse = await this.$store.dispatch(
        "session/finishPwdChange",
        solution
      );
      let redirect = await this.$store.dispatch(
        "profile/setStatus",
        chngResponse
      );

      await this.fetchOnLogin();

      return redirect;
    },
    async fetchOnLogin() {
      await this.$store.dispatch("myTodo/fetchCount");
      await this.$store.dispatch("purchase/hasActivePurchase");
    },
    async clearStore() {
      await this.$store.dispatch("myTodo/clear");
      await this.$store.dispatch("purchase/clear");
    },
  },
};
